var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitHubIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 24.71C7.21375 26.1563 3.6425 24.71 1.5 20.25",
    stroke: "#FAFBFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 26.5V22.4475C11.5 21.7 11.73 21.05 12.1 20.4625C12.355 20.06 12.18 19.4875 11.7213 19.3625C7.9175 18.315 5.25 16.6338 5.25 11.0563C5.25 9.60625 5.725 8.24375 6.56 7.05625C6.7675 6.76125 6.8725 6.61375 6.8975 6.48125C6.9225 6.34625 6.87875 6.1725 6.79125 5.8225C6.4375 4.4025 6.46125 2.89375 6.99125 1.535C6.99125 1.535 8.0875 1.17625 10.5838 2.735C11.1538 3.09125 11.4388 3.27 11.69 3.31C11.9413 3.35 12.2762 3.26625 12.9462 3.09875C13.9042 2.86125 14.8881 2.74409 15.875 2.75C16.8619 2.74579 17.8456 2.86334 18.8038 3.1C19.4738 3.2675 19.81 3.35 20.0613 3.31125C20.3113 3.27125 20.5962 3.0925 21.1662 2.73625C23.6625 1.1775 24.7588 1.53625 24.7588 1.53625C25.2888 2.895 25.3125 4.40375 24.9588 5.82375C24.8713 6.17375 24.8288 6.34875 24.8538 6.48125C24.8788 6.61375 24.9825 6.7625 25.19 7.0575C26.025 8.245 26.5 9.6075 26.5 11.0575C26.5 16.635 23.8325 18.3163 20.0287 19.3613C19.57 19.4875 19.395 20.06 19.65 20.4613C20.02 21.0488 20.25 21.6988 20.25 22.4475V26.5",
    stroke: "#FAFBFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHubIcon);
export default __webpack_public_path__ + "static/media/GitHubIcon.97ec33607a872e23b34449e3f29d3d91.svg";
export { ForwardRef as ReactComponent };